export default __webpack_public_path__ + "static/media/arrow-left-red.ea23c439.svg";